import { render, staticRenderFns } from "./LeaksTab.vue?vue&type=template&id=1f845d9a&scoped=true"
import script from "./LeaksTab.vue?vue&type=script&lang=js"
export * from "./LeaksTab.vue?vue&type=script&lang=js"
import style0 from "./LeaksTab.vue?vue&type=style&index=0&id=1f845d9a&prod&lang=scss&scoped=true"
import style1 from "./LeaksTab.vue?vue&type=style&index=1&id=1f845d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f845d9a",
  null
  
)

export default component.exports